import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Icon } from '@iconify/react'

import RoleChange from './RoleChange'
import { get, put } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import Pagination from '../../../../components/pagination/Pagination'
import PageLoader from '../../../../components/loader/PageLoader'
import FormLoader from '../../../../components/loader/FormLoader'
import StatusChange from './StatusChange'
import LocationChange from './LocationChange'

function Admin() {
  const { id } = useParams()
  const { notify, profile } = useGlobalContext()
  const [loading, setLoading] = useState(true)
  const [userData, setUserData] = useState<any>({})
  const [showRole, setShowRole] = useState(false)
  const [showStatusChange, setShowStatusChange] = useState(false)
  const [showLocationChange, setShowLocationChange] = useState(false)

  const navigate = useNavigate()
  const fetchUser = async () => {
    setLoading(true)
    get(`admin/profile?adminId=${id}`)
      .then((result: any) => {
        if (result.status === 200) {
          setUserData(result.data)
        } else {
          notify('error', result.message)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    fetchUser()
  }, [])

  ///Bookings
  const [bookings, setBookings] = useState<any>({})
  const [bookingsLoading, setBookingsLoading] = useState(true)
  const [paginationPage, setPaginationPage] = useState('default')

  const fetchBookings = async (
    page: number,
    usage: string,
    pageSize: number
  ) => {
    setBookingsLoading(true)
    let url = ''
    if (usage === 'all') {
      url = `admin/bookings?creatorId=${id}&page=${page}&limit=${pageSize}`
    } else {
      url = `admin/bookings?creatorId=${id}&page=${page}&limit=${pageSize}&from=${dates.from}&to=${dates.to}`
    }
    get(url)
      .then((result: any) => {
        if (result.status === 200) {
          setBookings(result)
        } else {
          notify('error', result.message)
        }
        setBookingsLoading(false)
      })
      .catch(() => {
        setBookingsLoading(false)
      })
  }
  useEffect(() => {
    fetchBookings(1, 'all', 10)
  }, [])

  /// Switch Tables
  const [tab, setTab] = useState('booking')

  //Filter
  const [dates, setDates] = useState({
    from: '',
    to: '',
  })
  const handleChange = (e: any) => {
    const { name, value } = e.target
    setDates((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }
  function handleFilter() {
    if (!dates.from || !dates.to) {
      notify('error', `Dates can't be empty`)
    } else {
      setPaginationPage('date')
      fetchBookings(1, 'filtered', 10)
    }
  }

  // Trigger Password Reset
  function handlePasswordReset() {
    // Logic for triggering password reset
    put(`admin/reset-password/${id}`, null)
      .then((result: any) => {
        if (result.status === 200) {
          notify('success', result.message || 'Password reset to phone number')
        } else {
          notify('error', result.message)
        }
      })
      .catch(() => {
        notify('error', 'Failed to send password reset link')
      })
  }

  return loading ? (
    <div className='home'>
      <PageLoader position='center' />
    </div>
  ) : (
    <div className='customer'>
      {showRole && (
        <RoleChange
          userData={userData}
          fetchUser={fetchUser}
          setShowRole={setShowRole}
        />
      )}
      {showLocationChange && (
        <LocationChange
          userData={userData}
          fetchUser={fetchUser}
          setShowLocationChange={setShowLocationChange}
        />
      )}
      {showStatusChange && (
        <StatusChange
          userData={userData}
          fetchUser={fetchUser}
          setShowStatusChange={setShowStatusChange}
        />
      )}
      <div className='top'>
        <div className='flex items-center'>
          <Icon
            icon='ion:return-up-back-outline'
            onClick={() => {
              navigate(-1)
            }}
          />
          <h2
            onClick={() => {
              navigate(-1)
            }}
          >
            Back
          </h2>
        </div>
      </div>
      {userData ? (
        <div className='customer-wrap '>
          <div className='one'>
            <div className='flex justify-between placed-cards'>
              <div className='placed-card'>
                <p>Total Bookings Charge</p>
                <h2>NGN{userData.costs.toLocaleString()}</h2>
              </div>
              <div className='placed-card'>
                <p>Total Bookings</p>
                <h2>{userData.bookings}</h2>
              </div>
            </div>
            <div className='flex details flex-wrap'>
              <div className='details-card'>
                <p>Full Name</p>
                <h3>{userData.name}</h3>
              </div>

              <div className='details-card'>
                <p>Phone number</p>
                <h3>{userData.phone}</h3>
              </div>

              <div className='details-card'>
                <p>Location</p>
                <h3 className='capitalize'>{userData.location}</h3>
                {profile.role === 'super admin' && profile._id !== id && (
                  <button onClick={() => setShowLocationChange(true)}>
                    Change
                  </button>
                )}
              </div>
              <div className='details-card'>
                <p>Role</p>
                <h3 className='capitalize'>{userData.role}</h3>
                {profile.role === 'super admin' && profile._id !== id && (
                  <button onClick={() => setShowRole(true)}>Change</button>
                )}
              </div>
              <div className='details-card'>
                <p>Status</p>
                <h3 className={`capitalize ${userData.status}`}>
                  {userData.status}
                </h3>
                {profile.role === 'super admin' && profile._id !== id && (
                  <button onClick={() => setShowStatusChange(true)}>
                    Change
                  </button>
                )}
              </div>
              <div className='details-card'>
                <p>Email address</p>
                <h3>{userData.email}</h3>
              </div>
              <div className='details-card'>
                <p>Trigger Reset</p>
                <div>
                  <button onClick={handlePasswordReset}>
                    Reset to Phone Number
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className='two'>
            <div className='two-wrapper'>
              <div className='wrap-top flex justify-between flex-wrap items-center'>
                <div className='flex buttons'>
                  <button
                    className={tab === 'booking' ? 'active' : ''}
                    onClick={() => setTab('booking')}
                  >
                    Booking List
                  </button>
                </div>
                <div className='flex date-filter'>
                  <div className='flex items-center'>
                    <input
                      type='date'
                      name='from'
                      value={dates.from}
                      onChange={handleChange}
                      max={new Date().toISOString().split('T')[0]}
                    />
                  </div>
                  <div className='flex items-center'>
                    <p>to</p>
                    <input
                      type='date'
                      name='to'
                      value={dates.to}
                      onChange={handleChange}
                      min={dates.from}
                      max={new Date().toISOString().split('T')[0]}
                    />
                  </div>

                  <button
                    disabled={!dates.from || !dates.to}
                    onClick={handleFilter}
                  >
                    filter
                  </button>
                </div>
              </div>
              <>
                <div className='home_tables'>
                  <div className='left'>
                    {bookingsLoading ? (
                      <FormLoader position='center' />
                    ) : (
                      <div className='table'>
                        {bookings.data.length > 0 ? (
                          <>
                            <table>
                              <thead>
                                <tr>
                                  <th>S/N</th>
                                  <th>Date/Time</th>
                                  <th>Value</th>
                                  <th>Delivery Type</th>
                                  <th>Tracking ID</th>
                                  <th>Status</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {bookings.data.map((item: any, i: number) => (
                                  <tr key={item.id}>
                                    <td>{i + 1}</td>
                                    <td className='count'>
                                      {new Date(item.dateTime).toLocaleString()}
                                    </td>
                                    <td className='count'>
                                      NGN {item.amount.toLocaleString()}
                                    </td>
                                    <td className='count'>{item.trackingId}</td>
                                    <td className='count'>
                                      {item.deliveryType}
                                    </td>
                                    <td>
                                      <span
                                        className={`chip ${item.status.code}`}
                                      >
                                        {item.status.description}
                                      </span>
                                    </td>
                                    <td>
                                      <span
                                        onClick={() =>
                                          navigate(`/admin/booking/${item.id}`)
                                        }
                                        className='view'
                                      >
                                        view
                                      </span>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </>
                        ) : (
                          <h1>No Bookings To Show</h1>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                {!bookingsLoading && (
                  <Pagination
                    className='pagination-bar'
                    currentPage={bookings.pagination.page}
                    totalCount={bookings.pagination.totalPages}
                    pageSize={bookings.pagination.limit}
                    onPageChange={(page: number, pageSize: number) => {
                      paginationPage === 'default'
                        ? fetchBookings(page, 'all', pageSize)
                        : fetchBookings(page, 'filtered', pageSize)
                    }}
                  />
                )}
              </>
            </div>
          </div>
        </div>
      ) : (
        <div>No User data to show</div>
      )}
    </div>
  )
}

export default Admin
